import { Component } from '@angular/core';

@Component({
  selector: 'pda-video-about',
  templateUrl: './video-about.component.html'
})
export class VideoAboutComponent {

}
